/**
 * Smart Reminder Defaults — category-specific lead days
 * Used by the auto-reminder engine to calculate when to notify.
 */

import type { AutoReminderCategory, ReminderTimingPreset, ReminderPreferences } from '../types/reminder';

export const SMART_LEAD_DAYS: Record<AutoReminderCategory, number> = {
  insurance: 30,
  id_document: 90,
  vehicle_registration: 30,
  warranty: 30,
  membership: 14,
  health: 14,
  financial: 30,
  important_date: 30,
};

export const FOLLOW_UP_DAYS_BEFORE = 7;

export const TIMING_OPTIONS: { value: ReminderTimingPreset; label: string }[] = [
  { value: 'smart', label: 'Smart' },
  { value: 14, label: '14 days' },
  { value: 30, label: '30 days' },
  { value: 60, label: '60 days' },
];

export const DEFAULT_REMINDER_PREFERENCES: ReminderPreferences = {
  enabled: true,
  timing: 'smart',
  emailEnabled: true,
  pushEnabled: true,
  recipientMode: 'owner',
};

export const RECIPIENT_MODE_OPTIONS: { value: ReminderPreferences['recipientMode']; label: string; description: string }[] = [
  { value: 'owner', label: 'Owner only', description: 'Only the profile owner receives reminders' },
  { value: 'owner_and_editors', label: 'Owner and Editors', description: 'Owner and all adult editors receive reminders' },
];

export function getLeadDays(
  category: AutoReminderCategory,
  timing: ReminderTimingPreset,
): number {
  if (timing === 'smart') return SMART_LEAD_DAYS[category];
  return timing;
}
